module.exports = __webpack_public_path__ + "img/major.879bfc66.png";